import { useEffect, useState } from "react";
import "./Leads.css";
import LeadsCards from "./LeadsCard";
import DateIcon from './img/date.png'

import Category from './img/category.png'
import Enquiry from './img/enquiry.png'
import Filter from './img/filter.png'
import Notes from './img/notes.png'
import Star from './img/star.png'
import Support from './img/001-customer-service.png'
import EnquiryFormModal from "./EnquiryFormModal";
import Select from "react-select"; // Import react-select
import * as XLSX from "xlsx";
import Header from "../Header";
import Sidebar from "../SideBar";
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";


function LeadsUpdated() {
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [menuOpen, setMenuOpen] = useState(false);
    const [activeTab, setActiveTab] = useState("all");
    const [modalType, setModalType] = useState(null);
    const [selectedDate, setSelectedDate] = useState("");
    const [customDate, setCustomDate] = useState({ from: "", to: "" });
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedService, setSelectedService] = useState("web-development");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [notes, setNotes] = useState("");
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [leads, setLeadsData] = useState([])
    const [entriesCount, setEntriesCount] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [showAssignSection, setShowAssignSection] = useState(false);
    const [showAssignSectionMain, setShowAssignSectionMain] = useState(false);
    const [showAssignSectionArchive, setShowAssignSectionArchive] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]); // Store selected lead IDs
    const [filterMode, setFilterMode] = useState("individual"); // "individual" | "combined"
    const [staffList, setStaffList] = useState([]); // Store staff list
    const [showExcelModal, setShowExcelModal] = useState(false);
    const [employeeViewFilter, setEmployeeViewFilter] = useState(null);
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
    const [excelUploadSuccess, setExcelUploadSuccess] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadedFileName, setUploadedFileName] = useState("");
    const { isSidebarOpen } = useSidebar();

    const openModal = (type) => {
        if (type === "filter") {
            setModalType("filter");
        } else {
            setModalType(type);
        }
    };

    const closeModal = () => {
        setModalType(null);
    };

    const openEnquiryModal = () => {
        setShowEnquiryModal(true);
    };

    const closeEnquiryModal = () => {
        setShowEnquiryModal(false);
        fetchLeadsData();
    };



    const services = [
        { value: "web-development", label: "Web Development" },
        { value: "mobile-app", label: "Mobile App" },
        { value: "seo", label: "SEO" },
        { value: "marketing", label: "Marketing" }
    ];
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [filterStarred, setFilterStarred] = useState(false);




    const applyFilters = () => {
        return leads.filter(lead => {
            // 🔸 Status filter
            if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // 🔸 Starred filter
            const isStarred = lead.star === true || lead.star === "true" || lead.star === 1 || lead.star === "1";
            if (filterStarred && !isStarred) return false;

            // 🔸 Date filter logic
            if (selectedDate) {
                const leadDate = new Date(lead.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

                if (selectedDate === "today") {
                    const today = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== today) return false;
                } else if (selectedDate === "yesterday") {
                    const yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    const yesterdayStr = yesterday.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== yesterdayStr) return false;
                } else if (selectedDate === "tomorrow") {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    const tomorrowStr = tomorrow.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                    if (leadDate !== tomorrowStr) return false;
                } else if (selectedDate === "custom") {
                    if (!customDate.from || !customDate.to) return false;

                    const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                    const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                    const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                    if (leadTimestamp < fromTimestamp || leadTimestamp > toTimestamp) return false;
                }
            }

            return true;
        });
    };

  




    const filteredServices = services.filter(service =>
        service.label.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const fetchLeadsData = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/leads/all/${isLoggedIn.user_id}`); // Fetch leads data
            const res = await response.json();
            setLeadsData(res.reverse());
            console.log(res)
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
            
        }
    }


    const handleEmployeeChange = (selectedOption) => {
        setSelectedEmployee(selectedOption ? selectedOption.value : ""); // Store selected employee
    };

    const employeeOptions = staffList.map(staff => ({
        value: staff.emplyee_ID,
        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`
    }));


    // useEffect(() => {
    //     setEntriesCount(1);
    // }, [leads]);
    const applyCombinedFilters = () => {
        if (!filtersApplied) return leads;

        return leads.filter(lead => {
            // ✅ Enquiry Status (from 'extra')
            if (selectedStatus && lead.extra?.toLowerCase() !== selectedStatus.toLowerCase()) return false;

            // ✅ Service filter
            // if (selectedService && lead.related_service?.toLowerCase() !== selectedService.toLowerCase()) return false;

            // ✅ Notes filter
            // if (notes.trim() !== "" && (!lead.remark || lead.remark.trim() === "")) return false;

            // ✅ Starred
            const isStarred = lead.starred === true || lead.starred === "true" || lead.starred === 1 || lead.starred === "1";
            if (filterStarred && !isStarred) return false;

            // ✅ Date logic
            const leadDate = new Date(lead.createdAt).toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });

            if (selectedDate === "today") {
                const today = new Date().toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                if (leadDate !== today) return false;
            } else if (selectedDate === "yesterday") {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                const yesterdayStr = yesterday.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                if (leadDate !== yesterdayStr) return false;
            } else if (selectedDate === "tomorrow") {
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);
                const tomorrowStr = tomorrow.toLocaleDateString("en-IN", { timeZone: "Asia/Kolkata" });
                if (leadDate !== tomorrowStr) return false;
            } else if (selectedDate === "custom") {
                if (!customDate.from || !customDate.to) return false;

                const leadTimestamp = new Date(lead.createdAt).setHours(0, 0, 0, 0);
                const fromTimestamp = new Date(customDate.from).setHours(0, 0, 0, 0);
                const toTimestamp = new Date(customDate.to).setHours(0, 0, 0, 0);

                if (leadTimestamp < fromTimestamp || leadTimestamp > toTimestamp) return false;
            }

            return true;
        });
    };

    

    useEffect(() => {
        fetchLeadsData();
    }, [])

    // const filteredLeads = activeTab === "new"
    //     ? (filterMode === "combined" ? applyCombinedFilters() : applyFilters()).filter(lead => lead.mark === "New")
    //     : (filterMode === "combined" ? applyCombinedFilters() : applyFilters());
   
    const allFilteredLeads = filterMode === "combined" ? applyCombinedFilters() : applyFilters();

    // For tab-specific display
    const filteredLeads = (() => {
        switch (activeTab) {
            case "new":
                return allFilteredLeads.filter(lead => lead.mark === "New" && !lead.status &&!lead.archive);
            case "assigned":
                return allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name && !lead.status &&!lead.archive);
            case "unassigned":
                return allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name && !lead.status);
            case "archive":
                return allFilteredLeads.filter(lead => lead.status === true || lead.status === "true");
            default:
                return allFilteredLeads.filter(lead => !lead.status &&!lead.archive); // Exclude archived leads from the default view
        }
    })();

    // ✅ Use this for All Enquiry count display (doesn't change based on tab)
    const totalAllCount = allFilteredLeads.filter(lead => (lead.mark === "New" || lead.mark === "Read")).length;
    const totalNewCount = allFilteredLeads.filter(lead => lead.mark === "New").length;
    const totalAssignedCount = allFilteredLeads.filter(lead => lead.staff_id && lead.staff_name).length;
    const totalUnassignedCount = allFilteredLeads.filter(lead => !lead.staff_id && !lead.staff_name).length;

    const totalArchiveCount = allFilteredLeads.filter(
        (lead) => lead.status === true || lead.status === "true"
    ).length;




    // 🔹 Calculate total pages for filtered leads
    const totalPages = Math.ceil(filteredLeads.length / entriesCount);

    // 🔹 Get leads for the current page
    const indexOfLastLead = currentPage * entriesCount;
    const indexOfFirstLead = indexOfLastLead - entriesCount;
    const paginatedCurrentLeads = filteredLeads
        .filter((lead) => !employeeViewFilter || lead.staff_id === employeeViewFilter)
        .slice(indexOfFirstLead, indexOfLastLead);


    // 🔹 Handle page change
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            setSelectAll(false); // Reset "Select All" checkbox
            setSelectedLeads([]); // Clear all selected checkboxes when changing page
        }
    };

    const toggleAssignSection = () => {
        if (showAssignSection) {
            // Clear all selected checkboxes when closing
            setSelectedLeads([]);
            setSelectAll(false);
        }
        setShowAssignSection(!showAssignSection);
    };

    const toggleAssignSectionMain = () => {
        if (showAssignSectionMain) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionMain(!showAssignSectionMain);
        setShowAssignSection(false);

    };

    const toggleAssignSectionArchive = () => {
        if (showAssignSectionArchive) {
            setSelectedLeads([]);
            setEmployeeViewFilter("")
            setSelectAll(false);
        }
        setShowAssignSectionArchive(!showAssignSectionArchive);
        setShowAssignSection(false);
        setShowAssignSectionMain(false);

    };

    const [newlyAssignedLeads, setNewlyAssignedLeads] = useState([]);
    const [alreadyAssignedLeads, setAlreadyAssignedLeads] = useState([]);


    const handleSelectAll = () => {
        setSelectedLeads(prevSelected => ({
            ...prevSelected,
            [currentPage]: selectAll ? [] : paginatedCurrentLeads.map(lead => lead.id),
        }));
        setSelectAll(!selectAll);
        setNewlyAssignedLeads([]);
        setAlreadyAssignedLeads([]);
    };

    const handleArchive = async () => {
        // Extract selected lead IDs
        
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to archive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`https://100billionoms.com/leads/archive-inquiries`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Archived ${res.archivedCount} leads successfully.`);
                // ✅ Refresh leads data
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to archive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error archiving leads:", error);
            alert("An error occurred while archiving leads.");
        }
    };


    const handleExcelUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            let jsonData = XLSX.utils.sheet_to_json(worksheet);

            // ✅ Add user_id to each record
            jsonData = jsonData.map(entry => ({
                ...entry,
                user_id: isLoggedIn.user_id
            }));

            const xhr = new XMLHttpRequest();
            xhr.open("POST", "https://100billionoms.com/leads/upload-excel");
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const percentComplete = Math.round((e.loaded / e.total) * 100);
                    setUploadProgress(percentComplete);
                } else {
                    let simulatedProgress = 0;
                    const interval = setInterval(() => {
                        simulatedProgress += 10;
                        setUploadProgress(Math.min(simulatedProgress, 99));
                        if (simulatedProgress >= 99) clearInterval(interval);
                    }, 200);
                }
            };

            xhr.onload = () => {
                if (xhr.status === 200) {
                    setExcelUploadSuccess(true);
                    setUploadProgress(0);
                    setTimeout(() => setExcelUploadSuccess(false), 3000);
                    setShowExcelModal(false);
                    fetchLeadsData();
                } else {
                    const response = JSON.parse(xhr.responseText);
                    alert(`Upload failed: ${response.message}`);
                    setUploadProgress(0);
                }
            };

            xhr.onerror = () => {
                alert("Network error occurred during upload.");
                setUploadProgress(0);
            };

            xhr.send(JSON.stringify({ enquiries: jsonData }));
        };

        reader.readAsArrayBuffer(file);
    };




    // 🔹 Handle Assign
    const handleAssign = async () => {
        if (!selectedEmployee || Object.keys(selectedLeads).length === 0) {
            alert("Please select an employee and at least one lead.");
            return;
        }

        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        const selectedStaff = staffList.find(emp => emp.emplyee_ID === selectedEmployee);
        if (!selectedStaff) {
            alert("Invalid employee selected.");
            return;
        }

        const payload = {
            leadIds: extractedLeadIds,
            staff_name: `${selectedStaff.firstName} ${selectedStaff.lastName}`,
            staff_id: selectedStaff.emplyee_ID
        };

        try {

            const response = await fetch(`https://100billionoms.com/leads/assign-leads`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert("Leads Processed Successfully!");

                // ✅ Update only newly assigned leads in the UI
                setLeadsData((prevLeads) =>
                    prevLeads.map((lead) =>
                        res.newlyAssignedIds.includes(lead.id) // Update only newly assigned leads
                            ? { ...lead, staff_name: selectedStaff.firstName + " " + selectedStaff.lastName, staff_id: selectedStaff.emplyee_ID }
                            : lead
                    )
                );

                // ✅ Store newly assigned leads separately
                setNewlyAssignedLeads(res.newlyAssignedIds);

                // ✅ Store already assigned leads separately
                setAlreadyAssignedLeads(res.alreadyAssignedIds);

            } else {
                console.error("Error assigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error assigning leads:", error);
            alert("An error occurred while assigning leads.");
        }
    };

    // 🔹 Handle Unassign
    const handleUnassign = async () => {
        if (Object.keys(selectedLeads).length === 0) {
            alert("Please select at least one lead to unassign.");
            return;
        }

        // Extract selected lead IDs from the object
        const extractedLeadIds = Object.values(selectedLeads).flat(); // Convert to a flat array

        if (extractedLeadIds.length === 0) {
            alert("No valid leads selected.");
            return;
        }

        const payload = {
            leadIds: extractedLeadIds, // ✅ Send correct array format
            staff_name: "", // ✅ Clear assigned staff
            staff_id: ""    // ✅ Clear assigned staff ID
        };

        try {

            const response = await fetch(`https://100billionoms.com/leads/unassign-leads`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert("Leads Unassigned Successfully!");
                fetchLeadsData(); // Refresh leads list
            } else {
                console.error("Error unassigning leads:", res);
                alert(`Error: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unassigning leads:", error);
            alert("An error occurred while unassigning leads.");
        }
    };


    const handleUnarchive = async () => {
        const extractedLeadIds = Object.values(selectedLeads).flat();

        if (extractedLeadIds.length === 0) {
            alert("Please select at least one lead to unarchive.");
            return;
        }

        const payload = { inquiryIds: extractedLeadIds };

        try {
            const response = await fetch(`https://100billionoms.com/leads/unarchive-inquiries`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const res = await response.json();

            if (response.ok) {
                alert(`Unarchived ${res.unarchivedCount} leads successfully.`);
                fetchLeadsData();
                setSelectedLeads([]);
                setSelectAll(false);
                setShowAssignSectionArchive(false);
            } else {
                alert(`Failed to unarchive leads: ${res.message}`);
            }
        } catch (error) {
            console.error("Error unarchiving leads:", error);
            alert("An error occurred while unarchiving leads.");
        }
    };


    const SearchStaff = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/staffregister/allget/${isLoggedIn.user_id}`); // Fetch staff data
            const res = await response.json();
           
            setStaffList(res); // ✅ Save staff data in state
        } catch (error) {
               toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    };




    useEffect(() => {
        SearchStaff();
    }, [])


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="ls-header">
                    <div className="ls-column">
                        <button className="ls-custom-button" onClick={openEnquiryModal}>Add Enquiry</button>
                    </div>

                    <div className="ls-column ls-icons-container">
                        <div className="ls-customer-support">
                            <a href="mailto:support@100billiontech.com" aria-label="Email Customer Support">
                                <img src={Support} alt="Customer Support Icon" /> Customer Support
                            </a>
                        </div>

                        {/* <i className="fas fa-globe ls-icon"></i> */}
                        {/* <div className="ls-menu-container" onClick={() => setMenuOpen(!menuOpen)}>
                        <div className="ls-menu-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        {menuOpen && (
                            <div className="ls-menu-content">
                                <p>Additional Content</p>
                            </div>
                        )}
                    </div> */}
                    </div>
                </div>

                <div className="ls-tabs">
                    <div className={`ls-tab ${activeTab === "all" ? "ls-active" : ""}`} onClick={() => {
                        setActiveTab("all");
                        setCurrentPage(1);
                    }}>
                        All Enquiry <span>({totalAllCount})</span>
                    </div>
                    <div className={`ls-tab ${activeTab === "new" ? "ls-active" : ""}`} onClick={() => {
                        setActiveTab("new");
                        setCurrentPage(1);
                    }}>
                        New <span>({totalNewCount})</span>
                    </div>
                    {/* <div className={`ls-tab ${activeTab === "assigned" ? "ls-active" : ""}`} onClick={() => { setActiveTab("assigned"); setCurrentPage(1); }}>
                        Assigned <span>({totalAssignedCount})</span>
                    </div>
                    <div className={`ls-tab ${activeTab === "unassigned" ? "ls-active" : ""}`} onClick={() => { setActiveTab("unassigned"); setCurrentPage(1); }}>
                        Unassigned <span>({totalUnassignedCount})</span>
                    </div>
                    <div className={`ls-tab ${activeTab === "archive" ? "ls-active" : ""}`} onClick={() => { setActiveTab("archive"); setCurrentPage(1); }}>
                        Archive <span>({totalArchiveCount})</span>
                    </div> */}

                    <div className="ls-entries">
                        <label style={{ fontWeight: "none" }}>Entries:</label>
                        <select value={entriesCount} onChange={(e) => {
                            setEntriesCount(Number(e.target.value));
                            setCurrentPage(1);
                        }}>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                            <option value="1000">1000</option>
                        </select>
                    </div>
                    {/* <div className="ls-buttonleadsupdated">
                    <button
                        className={`ls-buttonmainleadsupdated ${showAssignSection ? "ls-close" : ""}`}
                        onClick={toggleAssignSection}
                    >
                        {showAssignSection ? "Close" : "Assign Leads"}
                    </button>
                </div>
                <div className="ls-buttonleadsupdated">
                    <button
                        className={`ls-buttonmainleadsupdated ${showAssignSectionMain ? "ls-close" : ""}`}
                        onClick={toggleAssignSectionMain}
                    >
                        {showAssignSectionMain ? "Close" : "Check Assigned"}
                    </button>
                </div>

                <div className="ls-buttonleadsupdated">
                    <button
                        className={`ls-buttonmainleadsupdated ${showAssignSectionArchive ? "ls-close" : ""}`}
                        onClick={toggleAssignSectionArchive}
                    >
                        {showAssignSectionArchive ? "Close" : "Archive"}
                    </button>
                </div> */}
                    <div className="ls-buttonleadsupdated">
                        <button
                            className="ls-buttonmainleadsupdated"
                            onClick={() => setShowExcelModal(true)}
                        >
                            Upload Excel
                        </button>
                    </div>

                    <div className="ls-buttonleadsupdated">
                        <a
                            href="/LeadFormat.xlsx"
                            download
                            className="ls-download-format-btn"
                            style={{
                                marginLeft: "10px",
                                padding: "8px 12px",
                                background: "#4caf50",
                                color: "#fff",
                                borderRadius: "5px",
                                textDecoration: "none",
                                fontSize: "14px"
                            }}
                        >
                            <i className="fa-solid fa-file-arrow-down" style={{ marginRight: 6 }}></i>
                            Download Format
                        </a>
                    </div>
                </div>

                <div className="ls-filter">
                    <button className="ls-filter-btn" onClick={() => openModal("date")}>
                        <img src={DateIcon} alt="" /> Date
                    </button>
                    <button className="ls-filter-btn" onClick={() => {
                        setFilterStarred(!filterStarred);
                        setFiltersApplied(!filtersApplied); // So that filtering is applied immediately
                        setCurrentPage(1);
                    }}>
                        <img src={Star} alt="" /> {filterStarred ? "Starred" : "Star"}
                    </button>
                    {/* <button className="ls-filter-btn">
                    <img src={Notes} alt="" /> Notes
                </button>
                <button className="ls-filter-btn" onClick={() => openModal("service")}>
                    <img src={Category} alt="" /> Category/Service
                </button> */}
                    <button className="ls-filter-btn" onClick={() => openModal("status")}>
                        <img src={Enquiry} alt="" /> Enquiry Status
                    </button>
                    <button className="ls-filter-btn filter" onClick={() => openModal("filter")}>
                        <img src={Filter} alt="" /> Filter
                    </button>

                </div>


                {modalType && (
                    <div className="ls-modal">
                        <div className="ls-modal-content">
                            <h2>
                                {modalType === "date" && "Select Date"}
                                {modalType === "service" && "Select Category/Service"}
                                {modalType === "status" && "Select Enquiry Status"}
                                {modalType === "notes" && "Add Notes"}
                            </h2>

                            {modalType === "date" && (
                                <div className="ls-modal-content2">
                                    <div className="ls-modal-options">
                                        {["yesterday", "today", "custom"].map((option) => (
                                            <label
                                                key={option}
                                                className={`ls-radio-option ${selectedDate === option ? "selected" : ""}`}
                                                onClick={() => setSelectedDate(option)}
                                            >
                                                <input
                                                    type="radio"
                                                    name="date-filter"
                                                    value={option}
                                                    checked={selectedDate === option}
                                                    onChange={() => setSelectedDate(option)}
                                                />
                                                {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize first letter */}
                                            </label>
                                        ))}

                                        {selectedDate === "custom" && (
                                            <div className="ls-date-range">
                                                <div className="ls-date-from">
                                                    <label>From: </label>
                                                    <input
                                                        type="date"
                                                        className="ls-modal-input"
                                                        value={customDate.from}
                                                        onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
                                                    />
                                                </div>
                                                <div className="ls-date-to">
                                                    <label>To: </label>
                                                    <input
                                                        type="date"
                                                        className="ls-modal-input"
                                                        value={customDate.to}
                                                        onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="ls-modal-action">
                                        <button className="ls-modal-cancel" onClick={() => {
                                            closeModal()
                                            setSelectedDate("");
                                            setFiltersApplied(false);
                                        }}>Clear</button>
                                        <button
                                            className="ls-apply-btn"
                                            onClick={() => {
                                                setFiltersApplied(true);
                                                setFilterMode("individual"); // Use individual filter
                                                setCurrentPage(1);
                                                closeModal();
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            )}


                            {modalType === "service" && (
                                <div className="ls-modal-content2">
                                    <div className="ls-modal-options">
                                        {/* Search Box */}
                                        <div className="ls-radio-search">
                                            <i className="fas fa-search"></i>
                                            <input
                                                type="text"
                                                name="service-filter"
                                                placeholder="Search service..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>

                                        {/* Service Selection */}
                                        {filteredServices.map(service => (
                                            <label
                                                key={service.value}
                                                className={`ls-radio-option ${selectedService === service.value ? "selected" : ""}`}
                                                onClick={() => setSelectedService(service.value)} // Handle selection via label click
                                            >
                                                <input
                                                    type="radio"
                                                    name="service-filter"
                                                    value={service.value}
                                                    checked={selectedService === service.value}
                                                    onChange={() => setSelectedService(service.value)}
                                                />
                                                {service.label}
                                            </label>
                                        ))}
                                    </div>

                                    {/* Modal Actions */}
                                    <div className="ls-modal-action">
                                        <button className="ls-modal-cancel" onClick={closeModal}>Cancel</button>
                                        <button className="ls-apply-btn" onClick={closeModal}>Apply</button>
                                    </div>
                                </div>
                            )}


                            {modalType === "status" && (
                                <div className="ls-modal-content2">
                                    <div className="ls-modal-options">
                                        {["Pending", "In Process", "Cancelled", "Converted", "Not Interested"].map((status) => (
                                            <label
                                                key={status}
                                                className={`ls-radio-option ${selectedStatus === status ? "selected" : ""}`}
                                                onClick={() => setSelectedStatus(status)}
                                            >
                                                <input
                                                    type="radio"
                                                    name="status-filter"
                                                    value={status}
                                                    checked={selectedStatus === status}
                                                    onChange={() => setSelectedStatus(status)}
                                                    style={{ display: "none" }} // Hides the radio input
                                                />
                                                {status.charAt(0).toUpperCase() + status.slice(1)}
                                            </label>
                                        ))}
                                    </div>
                                    <div className="ls-modal-action">
                                        <button className="ls-modal-cancel" onClick={() => {
                                            closeModal();
                                            setSelectedStatus("");
                                            setFiltersApplied(false);
                                        }}>Clear</button>
                                        <button className="ls-apply-btn" onClick={() => {
                                            setFiltersApplied(true);
                                            setFilterMode("individual"); // Use individual filter
                                            setCurrentPage(1);
                                            closeModal();
                                        }}>Apply</button>

                                    </div>
                                </div>
                            )}

                            {modalType === "filter" && (
                                <div className="ls-modal">
                                    <div className="ls-modal-content">
                                        <h2>Filter Options</h2>

                                        {/* Date Filter */}
                                        <div className="ls-modal-section">
                                            <h3>Select Date</h3>
                                            <div className="ls-modal-options">
                                                {["yesterday", "today", "custom"].map((option) => (
                                                    <label
                                                        key={option}
                                                        className={`ls-radio-option ${selectedDate === option ? "selected" : ""}`}
                                                        onClick={() => setSelectedDate(option)}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="date-filter"
                                                            value={option}
                                                            checked={selectedDate === option}
                                                            onChange={() => setSelectedDate(option)}
                                                        />
                                                        {option.charAt(0).toUpperCase() + option.slice(1)} {/* Capitalize first letter */}
                                                    </label>
                                                ))}

                                                {selectedDate === "custom" && (
                                                    <div className="ls-date-range">
                                                        <div className="ls-date-from">
                                                            <label>From: </label>
                                                            <input
                                                                type="date"
                                                                className="ls-modal-input"
                                                                value={customDate.from}
                                                                onChange={(e) => setCustomDate({ ...customDate, from: e.target.value })}
                                                            />
                                                        </div>
                                                        <div className="ls-date-to">
                                                            <label>To: </label>
                                                            <input
                                                                type="date"
                                                                className="ls-modal-input"
                                                                value={customDate.to}
                                                                onChange={(e) => setCustomDate({ ...customDate, to: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Service Filter */}
                                        {/* <div className="ls-modal-section">
                                        <h3>Select Category/Service</h3>
                                        <div className="ls-modal-options">
                                            {filteredServices.map(service => (
                                                <label
                                                    key={service.value}
                                                    className={`ls-radio-option ${selectedService === service.value ? "selected" : ""}`}
                                                    onClick={() => setSelectedService(service.value)} // Handle selection via label click
                                                >
                                                    <input
                                                        type="radio"
                                                        name="service-filter"
                                                        value={service.value}
                                                        checked={selectedService === service.value}
                                                        onChange={() => setSelectedService(service.value)}
                                                    />
                                                    {service.label}
                                                </label>
                                            ))}
                                        </div>
                                    </div> */}

                                        {/* Status Filter */}
                                        <div className="ls-modal-section">
                                            <h3>Select Enquiry Status</h3>
                                            <div className="ls-modal-options">
                                                {["Pending", "In Process", "Cancelled", "Converted", "Not Interested"].map((status) => (
                                                    <label
                                                        key={status}
                                                        className={`ls-radio-option ${selectedStatus === status ? "selected" : ""}`}
                                                        onClick={() => setSelectedStatus(status)}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="status-filter"
                                                            value={status}
                                                            checked={selectedStatus === status}
                                                            onChange={() => setSelectedStatus(status)}
                                                            style={{ display: "none" }} // Hides the radio input
                                                        />
                                                        {status.charAt(0).toUpperCase() + status.slice(1)}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Notes Filter */}


                                        <div className="ls-modal-action">
                                            <button className="ls-modal-cancel" onClick={() => {
                                                closeModal()
                                                setSelectedStatus("");
                                                setFiltersApplied(false);
                                                setSelectedDate("");

                                            }}>Clear</button>
                                            <button className="ls-apply-btn" onClick={() => {
                                                setFiltersApplied(true);
                                                setFilterMode("combined"); // Use combined filter
                                                setCurrentPage(1);
                                                closeModal();
                                            }}>Apply filters</button>
                                        </div>
                                        <button className="ls-modal-close" onClick={closeModal}><i className="fa-solid fa-xmark"></i></button>
                                    </div>
                                </div>
                            )}

                            <button className="ls-modal-close" onClick={closeModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                    </div>
                )}
                {showAssignSection && (
                    <>
                        <div className="ls-assign-section">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                All
                            </label>
                            <Select
                                className="ls-select-employee"
                                options={employeeOptions}
                                isSearchable={true} // ✅ Enable search
                                placeholder="Search"
                                onChange={handleEmployeeChange}
                                value={employeeOptions.find(emp => emp.value === selectedEmployee)} // Preserve selection
                            />


                            <button className="ls-assign-btn" onClick={handleAssign}>Assign</button>
                            <button className="ls-unassign-btn" onClick={handleUnassign}>Unassign</button>
                            <div className="leadssmallscreenfeed">
                                <button className="ls-assignsmallleads-btn" onClick={handleAssign}>Assign</button>
                                <button className="ls-unassignsmallleads-btn" onClick={handleUnassign}>Unassign</button>
                            </div>
                        </div>

                    </>
                )}
                {showAssignSectionMain && (
                    <>
                        <div className="ls-assign-section">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                All
                            </label>
                            <div className="ls-employee-filter-select">
                                <Select
                                    options={staffList.map((staff) => ({
                                        value: staff.emplyee_ID,
                                        label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`,
                                    }))}
                                    placeholder="Filter by Assigned Employee"
                                    isClearable
                                    onChange={(selectedOption) =>
                                        setEmployeeViewFilter(selectedOption ? selectedOption.value : null)
                                    }
                                    value={
                                        employeeViewFilter
                                            ? {
                                                value: employeeViewFilter,
                                                label: staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.firstName +
                                                    " " +
                                                    staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.lastName
                                            }
                                            : null
                                    }
                                />
                            </div>



                            {/* <button className="ls-assign-btn" onClick={handleAssign}>Assign</button> */}
                            <button className="ls-unassign-btn" onClick={handleUnassign}>Unassign</button>
                            <div className="leadssmallscreenfeed">
                                {/* <button className="ls-assignsmallleads-btn" onClick={handleAssign}>Assign</button> */}
                                <button className="ls-unassignsmallleads-btn" onClick={handleUnassign}>Unassign</button>
                            </div>
                        </div>

                    </>
                )}

                {showAssignSectionArchive && (
                    <>
                        <div className="ls-assign-section">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        paginatedCurrentLeads.length > 0 &&
                                        selectedLeads[currentPage]?.length === paginatedCurrentLeads.length
                                    }
                                    onChange={handleSelectAll}
                                />
                                All
                            </label>
                            {/* <div className="ls-employee-filter-select"> */}
                            {/* <Select
                                options={staffList.map((staff) => ({
                                    value: staff.emplyee_ID,
                                    label: `${staff.firstName} ${staff.lastName} (ID: ${staff.emplyee_ID})`,
                                }))}
                                placeholder="Filter by Assigned Employee"
                                isClearable
                                onChange={(selectedOption) =>
                                    setEmployeeViewFilter(selectedOption ? selectedOption.value : null)
                                }
                                value={
                                    employeeViewFilter
                                        ? {
                                            value: employeeViewFilter,
                                            label: staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.firstName +
                                                " " +
                                                staffList.find((s) => s.emplyee_ID === employeeViewFilter)?.lastName
                                        }
                                        : null
                                }
                            /> */}
                            {/* </div> */}



                            {/* <button className="ls-assign-btn" onClick={handleAssign}>Assign</button> */}
                            <button className="ls-unassign-btn" onClick={handleArchive}>Archive</button>
                            <div className="leadssmallscreenfeed">
                                {/* <button className="ls-assignsmallleads-btn" onClick={handleAssign}>Assign</button> */}
                                <button className="ls-unassignsmallleads-btn" onClick={handleArchive}>Archive</button>
                            </div>
                            <button className="ls-unassign-btn" onClick={handleUnarchive}>Unarchive</button>
                            <div className="leadssmallscreenfeed">
                                {/* <button className="ls-assignsmallleads-btn" onClick={handleAssign}>Assign</button> */}
                                <button className="ls-unassignsmallleads-btn" onClick={handleUnarchive}>Unarchive</button>
                            </div>
                        </div>

                    </>
                )}
                {showExcelModal && (
                    <div className="excel-upload-modal">
                        <div className="excel-upload-content">
                            <div className="excel-upload-header">
                                <h2><i class="fa-regular fa-file-excel exceluploadbestfileget"></i> Upload Excel File</h2>
                                <button className="modal-close-btn" onClick={() => setShowExcelModal(false)}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>

                            <div className="excel-file-wrapper">
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    id="excel-upload"
                                    style={{ display: "none" }}
                                    onChange={(e) => {
                                        if (e.target.files.length > 0) {
                                            setUploadedFileName(e.target.files[0].name); // Show file name
                                            handleExcelUpload(e); // Trigger the upload
                                        }
                                    }}
                                />

                                <label htmlFor="excel-upload" className="custom-file-label">
                                    <i className="fa-solid fa-upload"></i> Choose Excel File
                                </label>
                                <p className="file-note">Only .xls and .xlsx files are allowed</p>
                            </div>
                            {uploadedFileName && (
                                <div className="uploaded-file-name">
                                    <i className="fa-solid fa-file-excel"></i> {uploadedFileName}
                                </div>
                            )}


                            {uploadProgress > 0 && (
                                <div className="progress-bar-container">
                                    <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                                        {uploadProgress}%
                                    </div>
                                </div>
                            )}

                            <div className="excel-upload-footer">
                                <button className="cancel-btn" onClick={() => setShowExcelModal(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {paginatedCurrentLeads.length > 0 ? (
                    <LeadsCards
                        leads={paginatedCurrentLeads}
                        setLeads={setLeadsData}
                        selectedLeads={selectedLeads}
                        setSelectedLeads={setSelectedLeads}
                        currentPage={currentPage}
                        newlyAssignedLeads={newlyAssignedLeads}
                        setNewlyAssignedLeads={setNewlyAssignedLeads}
                        alreadyAssignedLeads={alreadyAssignedLeads}
                        setAlreadyAssignedLeads={setAlreadyAssignedLeads}
                    />
                ) : (
                    <div className="no-leads-message">No leads available</div>
                )}
                <div className="pagination-container">
                    <button
                        className="pagination-btn"
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        ◀ Prev
                    </button>

                    <span className="pagination-info">
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        className="pagination-btn"
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next ▶
                    </button>
                </div>
                <EnquiryFormModal showEnquiryModal={showEnquiryModal} closeModal={closeEnquiryModal} />
            </div>
        </>
    );
};

export default LeadsUpdated;